import React from "react";
import CmTabs from "./Tabs";
import MiniDrawer from "../newNavBarCM/newNavBar";
import Layout from '../../NewComponent/LayoutCM/Layout';
export default function MainFile() {
  return (
    <div
      style={{
        // marginLeft:'auto',
        // marginRight:'auto',
        // width:'96%'
      }}
    >
      <Layout>
        <div style={{width:'95%',marginLeft:'auto',marginRight:'auto'}}>
      <CmTabs />
      </div>
      </Layout>
    </div>
  );
}
